import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import { remove } from "../../../reducers/transactions";

const Status = {
  success: "success",
  failed: "failed",
};

const useTransactions = () => {
  const dispatch = useDispatch();

  const [transaction, setTransaction] = useState(null);

  const mined = useSelector((state) => state.transactions.mined);
  useEffect(() => {
    if (!mined.length) return;

    const tx = mined[0];
    dispatch(remove({ hash: tx.hash }));

    setTransaction({
      status: Status.success,
    });
  }, [mined, setTransaction, dispatch]);

  const failed = useSelector((state) => state.transactions.failed);
  useEffect(() => {
    if (!failed.length) return;

    const tx = failed[0];
    dispatch(remove(tx.hash));

    setTransaction({
      status: Status.failed,
    });
  }, [failed, setTransaction, dispatch]);

  return transaction;
};

export default useTransactions;
